module.exports = __webpack_public_path__ + "img/tech-top.2f454a5.webp";